import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Typography, Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { TConfiguratorChoice } from '../../configuratorTemplates/_propTypes';
import {
  SelectionImg,
  SelectionDetails,
} from './styles';

const ProjectSummarySelection = ({ selectedCarpetChoiceText = null, carpetSelection, defaultImageUrl, isSkeleton }) => {

  if (isSkeleton) {
    return (
      <div className="selection-container">
        <Typography variant="h4" weight="bold">Selected Carpet:</Typography>
        <div className="selection-tile">
          <div className="selection-img">
            <img
              src={defaultImageUrl}
              alt="default_swatch_color"
              width="106"
              height="106"
            />
          </div>
          <div className="selection-details">
            <Typography paragraph>
              <Skeleton disablePadding grow>
                <SkeletonBlock height={16} />
              </Skeleton>
            </Typography>
            <Typography variant="h6" weight="bold">
              <span className="sui-inline-block">
                <SkeletonBlock height={3} width={12} />
              </span>
              <span>{' / sq. ft.'}</span>
            </Typography>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="selection-container">
      <Typography variant="h4" weight="bold">Selected Carpet:</Typography>
      {
        isEmpty(carpetSelection)
          ? <Typography paragraph>No carpet selected</Typography>
          : (
            <div className="selection-tile">
              <div className="selection-img">
                <img
                  src={carpetSelection.mediaUrl}
                  alt={`swatch_color_${carpetSelection.shortLabel}`}
                  width="106"
                  height="106"
                />
              </div>
              <div className="selection-details">
                <Typography paragraph>{selectedCarpetChoiceText}</Typography>
                <Typography variant="h6" weight="bold">{`$${carpetSelection.priceSquareFoot} / sq. ft.`}</Typography>
              </div>
            </div>
          )
      }
    </div>
  );
};

ProjectSummarySelection.propTypes = {
  selectedCarpetChoiceText: PropTypes.string.isRequired,
  carpetSelection: TConfiguratorChoice.isRequired,
  defaultImageUrl: PropTypes.string,
  isSkeleton: PropTypes.bool,
};

ProjectSummarySelection.defaultProps = {
  defaultImageUrl: null,
  isSkeleton: false,
};

export default ProjectSummarySelection;
